var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-h6 mt-1 mb-1 grey--text text--lighten-3"},[_c('v-icon',{attrs:{"small":"","color":"grey lighten-3"}},[_vm._v("mdi-timer-outline")]),_vm._v(" "+_vm._s(_vm.formattedElapsed)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }